// Themes

export const lightTheme = {
  body: "#FFF",
  text: "#292F33",
  secondaryText: "#5F6368",
  imageHighlight: "#0E6BA8",
  buttonColor: "#0A66C2",
  hoverButtonColor: "#084d92",
  headerColor: "#C0C0C0",
  highlight: "#EEEEEE",
  dark: "#202124",
  compImgHighlight: "#E1D9D1",
  jacketColor: "#0A2472",
  CompImgColor: "#292F33",
};

export const darkTheme = {
  body: "#121212",
  text: "#FFFFFFFF",
  secondaryText: "#FFFFFFb3",
  buttonColor: "#FFFFFFF2",
  hoverButtonColor: "#FFFFFFdb",
  imageHighlight: "#3700b3",
  headerColor: "#FF990070",
  highlight: "#2E2E2E",
  dark: "#000000",
  compImgHighlight: "#FFFFFF1a",
  jacketColor: "#8d99ae",
  CompImgColor: "#191919",
};

export const chosenTheme = lightTheme;
